/**
 *Function will work when the variant of the product will be changed
 */
function afterProductVaraintChange() {
  // eslint-disable-next-line func-names
  document.addEventListener('product:variant-change', function (evt) {
    const isAvailable = evt.detail.variant.available;
    const isComparedPrice = evt.detail.variant.compare_at_price;
    const iconInfo = document.querySelector('.product__details  .icon.icon-new.icon-info');
    const available = document.querySelector('.product__callouts-item.available');
    const notAvailable = document.querySelector('.product__callouts-item.not_available');
    if (iconInfo !== null) {
      if (isComparedPrice != null) {
        iconInfo.classList.remove('hidden');
      } else {
        iconInfo.classList.add('hidden');
      }
    }

    if (isAvailable) {
      notAvailable.classList.add('hidden');
      available.classList.remove('hidden');
    } else {
      notAvailable.classList.remove('hidden');
      available.classList.add('hidden');
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  afterProductVaraintChange();
});
